import type { MenuThemeKey } from "@qassist/schemas";

export interface MenuThemeDefinition {
  key: MenuThemeKey;
  name: { ar: string; en: string };
  description: { ar: string; en: string };
}

export const menuThemes: readonly MenuThemeDefinition[] = [
  {
    key: "mono-editorial",
    name: { ar: "أحادي تحريري", en: "Mono editorial" },
    description: {
      ar: "حبر أسود وورق أبيض ولمسة صفراء جريئة.",
      en: "Black ink, white paper, and a bold yellow accent.",
    },
  },
  {
    key: "modern-minimal",
    name: { ar: "عصري بسيط", en: "Modern minimal" },
    description: {
      ar: "مساحات هادئة وتسلسل بصري واضح.",
      en: "Quiet space and a clear visual hierarchy.",
    },
  },
  {
    key: "warm-bistro",
    name: { ar: "بيسترو دافئ", en: "Warm bistro" },
    description: {
      ar: "ألوان كريمية وعنابية بطابع حميم.",
      en: "Cream and burgundy with an intimate character.",
    },
  },
  {
    key: "luxury-dark",
    name: { ar: "فاخر داكن", en: "Luxury dark" },
    description: { ar: "فحمي وعاجي مع لمسات ذهبية.", en: "Charcoal, ivory, and restrained gold." },
  },
  {
    key: "rustic-kraft",
    name: { ar: "ريفي طبيعي", en: "Rustic kraft" },
    description: { ar: "ألوان ورقية وترابية دافئة.", en: "Warm paper and grounded earthy tones." },
  },
  {
    key: "mediterranean",
    name: { ar: "متوسطي", en: "Mediterranean" },
    description: { ar: "أبيض وأزرق بحري وتيراكوتا.", en: "White, sea blue, and terracotta." },
  },
  {
    key: "neon-street",
    name: { ar: "شارع نيون", en: "Neon street" },
    description: {
      ar: "داكن وحيوي لمطاعم الشارع.",
      en: "Dark and energetic for street-food menus.",
    },
  },
  {
    key: "pastel-cafe",
    name: { ar: "مقهى باستيل", en: "Pastel cafe" },
    description: {
      ar: "ألوان لطيفة وبطاقات مستديرة.",
      en: "Soft colors and friendly rounded cards.",
    },
  },
  {
    key: "elegant-serif",
    name: { ar: "سيريف أنيق", en: "Elegant serif" },
    description: {
      ar: "تحرير راقٍ وخطوط فاصلة دقيقة.",
      en: "Refined editorial type and fine rules.",
    },
  },
  {
    key: "bold-color-block",
    name: { ar: "كتل لونية جريئة", en: "Bold color block" },
    description: { ar: "ألوان كبيرة وهندسة قوية.", en: "Large color fields and strong geometry." },
  },
  {
    key: "fresh-organic",
    name: { ar: "طبيعي منعش", en: "Fresh organic" },
    description: {
      ar: "أخضر طبيعي ودرجات دافئة هادئة.",
      en: "Natural green and calm warm neutrals.",
    },
  },
  {
    key: "classic-diner",
    name: { ar: "داينر كلاسيكي", en: "Classic diner" },
    description: {
      ar: "أحمر وكريمي وكحلي بطابع كلاسيكي.",
      en: "Red, cream, and navy diner polish.",
    },
  },
  {
    key: "modern-arabesque",
    name: { ar: "عربي معاصر", en: "Modern arabesque" },
    description: {
      ar: "ألوان جوهرية وهندسة عربية معاصرة.",
      en: "Jewel tones and contemporary Arabic geometry.",
    },
  },
] as const;

export function menuTheme(key: MenuThemeKey): MenuThemeDefinition {
  return menuThemes.find((theme) => theme.key === key) ?? menuThemes[0]!;
}
